// src/hooks/useFilteredNavigationItems.ts
import type {AuthenticatedNavigationItem} from "@/features/layout/config/navigation";
import {
  
  getAuthenticatedNavItems
} from "@/features/layout/config/navigation";

/**
 * Returns filtered navigation items based on feature flags.
 * Currently returns all items - extend this to filter by feature flags as needed.
 */
export function useFilteredNavigationItems(): Array<AuthenticatedNavigationItem> {
  const navItems = getAuthenticatedNavItems();
  // Filter by feature flags if needed in the future
  return navItems;
}
